exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table .avatar[data-v-0a5b345c]{width:40px;height:40px;border-radius:50%;vertical-align:middle;-o-object-fit:cover;object-fit:cover}table tbody td.username span.el-tag[data-v-0a5b345c]{float:right}.pay[data-v-0a5b345c]{padding:0 10px}.pay li[data-v-0a5b345c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.pay li *[data-v-0a5b345c]:nth-child(2){font-weight:bold}.increase[data-v-0a5b345c]{color:#0abb87}.decrease[data-v-0a5b345c]{color:#c03639}", ""]);

// exports
